export const ROLES = {
  admin: {
    label: "Admin",
    role: "a2470ee4",
  },
  operator: {
    label: "Operador",
    role: "a2470ee3",
  },
  qr: {
    label: "QR",
    role: "a2470ee2",
  },
};

export const ROLES_RAW = Object.values(ROLES).map((r) => r.role);

export const ROLE_OPTS = Object.values(ROLES).map((r) => ({
  label: r.label,
  value: r.role,
}));
